// extracted by mini-css-extract-plugin
export var wrapper = "TripleHighlights-module--wrapper--bOnGm";